module.exports = __webpack_public_path__ + "img/ideavr.8b1b9da3.png";